import React  from "react";
import HeaderThree from "../HeaderThree/Main";
import FooterThree from "../FooterThree/Main";
import CtaThree from "../Menhomethree/CtaThree";
import BlogThree from "../Menhomethree/BlogThree";
import TestimonialThree from "../Menhomethree/TestimonialThree";
import Partner from "../Menhomethree/Partner";
import ProjectOne from "../Menhomethree/ProjectOne";
import ProcessOne from "../Menhomethree/ProcessOne";
import VideoOne from "../Menhomethree/VideoOne";
import ServiceThree from "../Menhomethree/ServiceThree";
import AboutTwo from "../Menhomethree/AboutTwo";
import BannerThree from "../Menhomethree/BannerThree";

function Main() {

  return (
    <div>
      <HeaderThree />
      <div className="main-wrapper">
        <div className="data-scroll">
          <div className="page-wrapper">
            <main>
              <BannerThree />
              <AboutTwo />
              <ServiceThree />
              <VideoOne />
              <ProcessOne />
              <ProjectOne />
              <Partner />
              <TestimonialThree />
              <BlogThree />
              <CtaThree />
            </main>
            <FooterThree />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;
